import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useUser = (defaultPageSize, isFetch, roleId) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    firstname: "",
    lastname: "",
    personal: "",
    email: "",
    mobile: "", 
    role_id: roleId,
  });

  useUpdateEffect(() => {
    if (defaultPageSize > 0) {
      fetchList(); 
    }
    }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/user/list", filter)
      setItems(response.data.users);
      setTotal(response.data.total);
      return response.data.users
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const bulkSms = (text) => {
    return new Promise((resolve, reject) => {
      
      const requestData = {
        filter: filter,
        text: text, 
      };

      automobyApi.post(`/user/bulksms`, requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 0
      };

      const response = await automobyApi.post("/user/all", requestData)
      setItems(response.data.users);
      setTotal(response.data.total);
      return response.data.users
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/user/create`, newData)
        .then(response => {
          fetchList();
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          if (error.response && error.response.data && error.response.data.message) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  };
  

  const search = async (user, count) => {
    try {
      const requestData = {
        user: user,
        count: count,
      };

      const response = await automobyApi.post("/user/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/user/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const updateFiles = async (newData) => {
    try {
      const response = await automobyApi.post(`/user/update/id-file`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const updatePassword = (user) => {
    return new Promise((resolve, reject) => {

     
        const requestData = {
          user: user, 
        };

      automobyApi.post(`/user/update/password`, requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  const forgot = (user) => {
    return new Promise((resolve, reject) => {
 
        const requestData = {
          user: user, 
        };

      automobyApi.post(`/user/forogot`, requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  const updateCurrent = (newData) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/user/update/current`, newData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  const ping = (userId) => {
    return new Promise((resolve, reject) => {
      automobyApi.post(`/user/ping`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }

  const loginAsUser = (userId) => {
    return new Promise((resolve, reject) => {
      const requestData = { user_id: Number(userId) };

      automobyApi.post(`/loginAsUser`, requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }


  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          user_id: id
        };
        const response = await automobyApi.post(`/user/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const fetchCurrentUser = () => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/user/current")
        .then(response => {
          resolve(response.data.user);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const updateLocal = async (user) => {
    setItems(items.map(item =>
      item.id === user.id ? user : item
    ));
  }
 


  const getUserById = async (id) => {
    try {

      const requestData = {
        user_id: Number(id)
      };

      const response = await automobyApi.post("/user/get", requestData)
      return response.data
    } catch (error) {
      console.error("ერორი:" + error);
    }
  }

  
  const userService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    getUserById: getUserById,
    bulkSms : bulkSms,
    search: search,
    update: update,
    updateFiles: updateFiles,
    remove: remove,  
    updatePassword: updatePassword,
    forgot: forgot,
    fetchCurrentUser: fetchCurrentUser,
    updateCurrent: updateCurrent,
    loginAsUser: loginAsUser,
    ping, ping
  };

  return { userService };
}